import type React from 'react';

import cn from 'classnames';

import type { Consultation } from '@shared/types/consultations';

import { ScheduleStatuses } from '@src/library/types/schedules';

import * as st from './Status.module.scss';

type Props = {
	consultation: Consultation;
};

const Status: React.FC<Props> = ({ consultation }) => {
	const status = () => {
		let status = ScheduleStatuses.unconfirmed;

		if (consultation.paid.paid) {
			status = ScheduleStatuses.confirmed;
		}

		if (consultation.cancelled) {
			status = ScheduleStatuses.cancelled;
		}
		return status;
	};

	const text = {
		unconfirmed: 'Не подтверждена',
		cancelled: 'Отменена',
		confirmed: '',
	};

	return <div className={cn(st.status, st[status()])}>{text[status()]}</div>;
};

export default Status;
